import React from 'react';
import parse from "html-react-parser";

import {Body, Header3} from "../styled/typography/Typography";
import {ContentLibrarySideWrapper} from "../styled/pages/about/content-library/ContentLibraryComponents";
import {ToggleButton, ToggleCardWrapper} from "../styled/pages/solutions/SolutionsComponents";

import ToggleIcon from "../../../static/assets/icon_down_arrow.svg";

const ToggleCard = ({title, description}) => {
    return (
        <ContentLibrarySideWrapper nomargin="true">
            <ToggleCardWrapper>
                <summary>
                    <Header3 color="body-text">{title}</Header3>
                    <ToggleButton>
                        <img src={ToggleIcon} alt="toggle"/>
                    </ToggleButton>
                </summary>
                <Body color="body-text">
                    {parse(description)}
                </Body>
            </ToggleCardWrapper>
        </ContentLibrarySideWrapper>
    );
};

export default ToggleCard;